import React, { useState, useEffect} from 'react';
import BannerInner from '../components/BannerInner';
import { BsStarFill} from "react-icons/bs";
import CommonHelmet from '../components/CommonHelmet';
import UserIcon from '../assets/images/user_icon.png';
import axios from 'axios';

const Testimonials = () => {
    const title='Real Estate Consultant in Lucknow | Best Real Estate Company';
    const description='Urbanaid Infratech is the leading Property Consultants in Lucknow. We are a top class real estate builders in Lucknow. Visit urbanaidinfratech.com to check upcoming projects.';
    const canonical='/about';

    const [testimonialData, setTestimonialData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get("/api/alltestimonials"); // Adjust port if needed
                const fetchedData = res.data; // Assuming data is an array
                setTestimonialData(fetchedData);
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };
        fetchData();
    }, []);

    return (
        <>
            <CommonHelmet title={title} canonical={canonical} description={description} />
            <BannerInner title={'Testimonials'} />
            <section className='aboutus flex py-8'>
                <div className='container mx-auto'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-10'>
                    {testimonialData.map((data, idx) => (     
                        <div key={idx} className='flex flex-col space-y-2 relative md:pr-10'>                   
                            <div className='flex flex-col border border-gray-200 bg-gray-50 border-solid text-gray-700 text-left relative items-baseline rounded-md p-6 pb-10'>
                                <p>"{data.message}"</p>
                            </div>
                            <div className='flex flex-col space-y-1 px-6'>
                                <span className='font-semibold'>{data.clientname}</span>
                                <span className='flex flex-row space-x-2'><BsStarFill className='text-yellow-400' /><BsStarFill className='text-yellow-400' /><BsStarFill className='text-yellow-400' /><BsStarFill className='text-yellow-400' /><BsStarFill className='text-yellow-400' /></span>
                            </div>
                            <div className='absolute bottom-0 right-14 rounded-full border border-gray-200 bg-white shadow-sm p-3'><img src={UserIcon} className=' w-14' /></div>
                        </div>
                    ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Testimonials;
